// Ta funkcja jest już poprawna. Inicjalizuje wszystkie znalezione slidery.
const initVehicleSliders = () => {
  const sliders = document.querySelectorAll('.swiper-vehicle-gallery');

  if (!sliders.length) {
    console.log('Swiper: Nie znaleziono żadnych galerii do uruchomienia.');
    return;
  }

  sliders.forEach(slider => {
    // Sprawdzamy, czy ten konkretny slider nie został już zainicjowany
    if (slider.classList.contains('swiper-initialized')) {
      return;
    }

    new Swiper(slider, {
      loop: true,
      grabCursor: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
    });
  });

  console.log(`Swiper: Pomyślnie zainicjowano ${sliders.length} galerii.`);
};


// === KLUCZOWA ZMIANA JEST TUTAJ ===
// Czekamy, aż cała strona się załaduje, a NASTĘPNIE czekamy dodatkowe pół sekundy.
// To daje pewność, że wszystkie skrypty WooCommerce'a skończyły swoją pracę.
window.addEventListener('load', () => {
  setTimeout(initVehicleSliders, 500); // Czekaj 500 milisekund (pół sekundy)
});

